/**
 * Parse timestamps from the API. DB values are UTC:
 * - SQLite `datetime('now')` → `YYYY-MM-DD HH:MM:SS` (no zone)
 * - Telegram/ISO → `...Z` or with offset
 */
export function parseUtcDate(value: string): Date {
  const s = value.trim();
  if (!s) return new Date(NaN);
  // SQLite-style UTC without timezone → treat as UTC
  if (/^\d{4}-\d{2}-\d{2}[ T]\d{2}:\d{2}(:\d{2})?(\.\d+)?$/.test(s)) {
    return new Date(`${s.replace(' ', 'T')}Z`);
  }
  return new Date(s);
}

/** Format a UTC DB/API timestamp in the viewer's local timezone. */
export function formatDateTime(iso: string): string {
  const months = ['jan', 'feb', 'mrt', 'apr', 'mei', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec'];
  const d = parseUtcDate(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return `${d.getDate()} ${months[d.getMonth()]} ${d.getFullYear()} ${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`;
}

export function highlightText(text: string, query: string): string {
  if (!query.trim()) return escapeHtml(text);
  const words = query.trim().split(/\s+/).filter(Boolean);
  let out = escapeHtml(text);
  for (const w of words) {
    const re = new RegExp(`(${escapeRegExp(w)})`, 'gi');
    out = out.replace(re, '<mark>$1</mark>');
  }
  return out;
}

function escapeHtml(s: string): string {
  return s
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

function escapeRegExp(s: string): string {
  return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

export function linkify(html: string): string {
  return html.replace(
    /(https?:\/\/[^\s<>"']+)/g,
    '<a href="$1" target="_blank" rel="noopener noreferrer">$1</a>',
  );
}

export function mediaUrl(mediaPath: string): string {
  return `/media/${encodeURIComponent(mediaPath)}`;
}

export function isImageMedia(mediaPath: string): boolean {
  // Known image extensions, or extensionless legacy downloads (server sniff + Content-Type)
  return /\.(jpe?g|png|webp|gif|bmp|tiff?)$/i.test(mediaPath) || !/\.[a-z0-9]{2,5}$/i.test(mediaPath);
}
